import axios from 'axios'
import QueryParamsUtil from 'api/utils/query-params-util'

const API_PATH = 'api/v2/admins/cities'

const CitiesApiV2 = {
  /**
   * Get list of `City`
   * @param {object} filters, possible value: { province_id: number, province_name: string }
   * @return {object} Collection of `Cities`
   */
  get: async (filters) => {
    const params   = QueryParamsUtil.format(null, filters)
    const response = axios.get(API_PATH, { params })

    return response
  }
}

export default CitiesApiV2
